import { getAllTagList } from "@/api/tag";

const userTag = {
  state: {
    list: [],
    map: {}
  },

  mutations: {
    updateUserTag: state => {
      getAllTagList()
        .then(response => {
          const list = response.data.tagItems || [];
          state.list = list;
          state.map = list.reduce((total, current) => {
            total[current.tagId] = current.tagName;
            return total;
          }, {});
        })
        .catch(error => {
          reject(error);
        });
    }
  },

  actions: {
    // 获取所有用户标签
    getUserTagList({ commit, state }) {
      return new Promise((resolve, reject) => {
        getAllTagList()
          .then(response => {
            commit("SET_LIST", response.data.tagItems);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};

export default userTag;



// WEBPACK FOOTER //
// ./src/store/modules/userTag.js